import React from "react";
import styled from "styled-components";
import { Form, Button, Row, Col } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import accessDeniedLogo from "../../assets/accessdenied.png";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
  isUserLoggedIn,
  getMenuItems,
  loggedUser,
} from "../../utils/functions/functionsUtils";
import { ScrollView } from "devextreme-react";

const AccessDeniedContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 40px;
`;

const FormContainer = styled(Form)`
  min-height: 300px;
  display: block;
  margin-bottom: 40px;
  text-align: center;
`;

const HomeButtonDiv = styled.div`
  margin-top: 35px;
  display: flex;
  justify-content: space-between;
`;

const HomeButton = styled(Button)`
  margin-left: 30px;
  min-width: 120px;
  max-height: 40px;
  margin-top: 105px;
`;

const HomeButtonText = styled.span`
  padding-left: 5px;
`;

const BoxTitle = styled.h2`
  font-size: 18px;
`;

const BoxSubTitle = styled.h4`
  font-size: 12px;
`;

const AccessDeniedLogo = styled.img`
    margin 15px;
    height:130px;
`;

function AccessDenied() {
  const navigate = useNavigate();
  const location = useLocation();
  //Translation module
  const { t } = useTranslation();
  //*******************

  const backToHome = async () => {
    if (isUserLoggedIn() && Object.keys(getMenuItems()).length > 0) {
      switch (loggedUser().role) {
        case "Administrator": {
          navigate("/dashboard");
          break;
        }
        default: {
          navigate("/services");
        }
      }
    }
  };

  if (location.pathname !== "/" && location.pathname !== undefined) {
    toast.error(`${t("UserNoAccess")} : ${location.pathname}`, {
      position: "top-right",
    });
  }

  return (
    <ScrollView height={window.innerHeight - 150} direction="vertical">
      <AccessDeniedContainer>
        <Row>
          <Col className="d-flex">
            <FormContainer>
              <BoxTitle>{t("AccessDenied")}</BoxTitle>
              <BoxSubTitle>
                {t("UserHasNoAccess")}
                {location.pathname}
              </BoxSubTitle>
              <Form.Group id="grpAccessDenied">
                <HomeButtonDiv>
                  <AccessDeniedLogo src={accessDeniedLogo} />
                  <HomeButton variant="primary" onClick={backToHome}>
                    <FontAwesomeIcon
                      icon={["fas", "home"]}
                      style={{ color: "#141B4D" }}
                    />
                    <HomeButtonText>Home</HomeButtonText>
                  </HomeButton>
                  <ToastContainer />
                </HomeButtonDiv>
              </Form.Group>
            </FormContainer>
          </Col>
        </Row>
      </AccessDeniedContainer>
    </ScrollView>
  );
}

export default AccessDenied;
